import JobLayout from 'components/JobLayout';
import ApplyHeader from 'pages/StartApplication/components/ApplyHeader';
import ApplyProvider from 'pages/StartApplication/components/ApplyProvider';
import { Declined as ApplyDeclined } from '@kanda-libs/ks-apply';
import { FunctionComponent } from 'react';

const Referred: FunctionComponent = function () {
  return (
    <ApplyProvider>
      <JobLayout header={<ApplyHeader />} showJobCard={false}>
        <ApplyDeclined />
      </JobLayout>
    </ApplyProvider>
  );
};

export default Referred;
